// extracted by mini-css-extract-plugin
export default {"parentRow":"GroupContent_parentRow__4v8d4","ant-table-row-selected":"GroupContent_ant-table-row-selected__SAD+H","childRow":"GroupContent_childRow__zvtm4"};